<template>
  <div v-if="JSON.stringify(detailConfig) !== '{}'" class="custom-box" :style="{ width: detailConfig.configList[customCanvasIndex].canvasWidth + 'px', height: detailConfig.configList[customCanvasIndex].canvasHeight + 'px' }">
    <cardForm 
      :data="tableData" 
      :cardConfig="detailConfig"
      :commentData="commentData"
      @edit-btn="$emit('edit-btn')" 
      @del-btn="$emit('del-btn')" 
      @blockchain-btn="$emit('blockchain-btn')"
      @dataArchiving-btn="$emit('dataArchiving-btn')"
      @app-print="(printId) => {$emit('app-print', printId)}" 
      @openAppInitiate="openAppInitiate"
      @custom-scene="customScene"
    />
    <!-- @openAppInitiate="val => { $emit('openAppInitiate', val) }"
      @edit-user-info="(val, row) => { $emit('edit-user-info', val, row) }"
      @appPrint="(val) => { $emit('appPrint', val) }"
      @edit-btn="$emit('edit-btn', item)" 
      @del-btn="$emit('del-btn', index)" 
      @open-appDialog="val => { $emit('open-appDialog', val) }"
      @custom-scene="val => { $emit('custom-scene', val) }" -->
    <!-- 发起 -->
    <app-dialog 
      :dialogInfo="{
        dialogName: openInput.name,
        isVisible: openInput.isVisible,
        dialogWidth: '80%',
        dialogHeight: '85vh'
      }"
      :iId="openInput.iId"
      v-model:isDetail="openInput.isDetail"
      :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow"
      :coverVal="openInput.search"
      :datatype="openInput.datatype"
      @doorUp="doorUp"
      @close="doorUpCloe" />
    <!-- 自定义场景 -->
    <el-dialog
      v-if="popUps"
      class="popUps"
      append-to-body
      top="0"
      @close="dialogClose"
      v-model:visible="popUps"
      :width="popUpsObj.popUps.w + 'px'">
      <iframe :style="{height:popUpsObj.popUps.h + 'px'}"
        :frameborder="0"
        seamless
        scrolling="auto"
        allowtransparency="true"
        id="iframe"
        :height="popUpsObj.popUps.h"
        width="100%"
        :src="popUpsObj.url" />
    </el-dialog>
  </div>
  <el-empty v-else :image-size="450" description="暂无配置"></el-empty>
</template>

<script>

import {
  sliceEncrypt,
} from "@/api/global.js";
import { defineAsyncComponent } from "vue";

export default {
  name: 'customWidgetOneLayer',
  props:{
    detailConfig: {
      type: Object,
      default: ()=>{}
    }, 
    tableData: {
      type: Object,
      default: ()=>{}
    },
    workshopFormdata: {
      type: Object,
      default: ()=>{}
    },
    ruleListChild: {
      type: Array,
      default: ()=>[]
    },
    commentData: {
      type: Object,
      default: () => {}
    },
    // 弹窗的样式
    popupStyle: { 
      type: String,
      default: 'default'
    },
    skey: { 
      type: String,
      default: ''
    },
    customCanvasIndex: { 
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isCanvas: true, // 用来刷新画布
      canvasList:['画布1'],
      canvasData: null, // 画布数据
      canvasIndex: 0, // 当前画布的位置
      activatedIndex: 0, // 当前选中的控件
      w: 1200,
      h: 1000,
      bgURL: '',
      detailDataType:'', // 他表的详细数据的控件类型
      customize:[], // 自定义图文的数据
      // 打开应用
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      },
      formdata: {},
      openAddInputShow: false, // 发起单独使用的
      // 弹窗
      popUps: false,
      popUpsObj: {
        popUps: {},
        url: ''
      },
    }
  },
  components: {
    AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
    cardForm: defineAsyncComponent(() => import('@/components/common/card/cardForm.vue'))
  },
  computed:{
    // 配置区域的背景
    mainBg() {
      let obj = {}
      if(this.detailConfig){
        const config = this.detailConfig.configList[this.customCanvasIndex]
        obj = {
          width: config.canvasWidth + 'px',
          height: config.canvasHeight + 'px',
          boxShadow: config.shadow ? 'rgb(201, 201, 201) 1px 1px 5px' : '',
          '--grid-size': config.gridSize + 'px'
        }
        if (config.backgroundValue === 0) {
          obj.backgroundColor = config.backgroundColor
        } else {
          const img = this.$imgurl
          obj.background = `url(${img}${config.backgroundImage}) no-repeat`
          obj.backgroundColor = '#ffffff'
          obj.backgroundSize = '100% 100%'
          obj.opacity = config.percentage / 100
        }
      }
      return obj
    },
    dealButonData () {
      const data = JSON.parse(JSON.stringify(this.formdata))
      const resData = {}
      for (let key in data) {
        const _key = key.split('_')[0]
        if (_key) {
          resData[_key] = data[key]
        }
      }
      return [resData]
    },
    canvasChildren () {
      let arr = []
      // 目前只需要用到表单的数据
      if (this.customCanvasIndex !== undefined && this.detailConfig.configList[this.customCanvasIndex]) {
        arr = this.detailConfig.configList[this.customCanvasIndex].children.map(item => { return item })
      }
      return arr
    },
  },
  watch: {
    detailConfig: {
      handler(newVal) {
        if(newVal){
          if (newVal.canvasHeight != this.h || newVal.canvasWidth != this.w || newVal.backgroundImage != this.bgURL) {
            this.h = newVal.canvasHeight
            this.w = newVal.canvasWidth
            this.bgURL = newVal.backgroundImage
          }
        }
      },
      deep: true,
      immediate: true
    },
    tableData: {
      async handler (newVal) {
        if (newVal) {
          this.formdata = newVal
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    getOverflowVal (item) {
      if (item && item.type.search('customize') !== -1)  return 'hidden'
      let val = 'auto'
      if (item.exceedType !== undefined) {
        if (item.exceedType === 0 || item.exceedType === 2) {
          val = 'hidden'
        } else if (item.exceedType === 1) {
          val = 'auto'
        }
      } 
      return val
    },
    // 富文本高度自适应 富文本下面的控件都要往下移动
    changeItemTop ({ item, differHeight }) {
      const activeIndex = this.customCanvasIndex
      // eslint-disable-next-line vue/no-mutating-props
      this.detailConfig.configList[activeIndex].canvasHeight += differHeight
      for(const key in this.detailConfig.configList[activeIndex].children) {
        const itemList = this.detailConfig.configList[activeIndex].children[key]
        if (Array.isArray(itemList) && itemList.length > 0) {
          itemList.forEach(iter => {
            if (iter.y > item.y) {
              iter.y += differHeight
              iter.differHeight += differHeight
            }
          })
        }
      }
    },
    // 判断是不是本表
    isOtherTable(val) {
      // 复制过来的问题
      if (this.detailConfig.dataSource.field && val.appid && this.detailConfig.dataSource.field[val.appid] == undefined) {
        return false
      }
      if (val.appid && val.appid != this.detailConfig.dataSource.appid) {
        return true
      }
    },
    // 自定义场景的方法
    dialogClose() {
      this.popUpsObj = {
        popUps: {},
        url:''
      }
    },
    customScene(obj) {
      this.popUpsObj = obj
      this.popUps = true
    },
    // 站内应用的方法
    doorUp() {
      // TODO 刷新列表
      this.handleListInfo(this.dataInfo.pageId)
    },
    doorUpCloe () {
      this.openInput = {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      }
      // this.openInput.isVisible = false
    },
    openAppInitiate ({approvalId, name, search, iId, id, datatype}) {
      this.openInput = {
        isVisible: true,
        approvalId: approvalId,
        name: name,
        search: search,
        iId: iId,
        isDetail: iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
        id: id || '',
        datatype: datatype
      }
      this.openAddInputShow = true
    },
    // 根据 title 查询具体数据
    getTempConfig (key) {
      const ind = this.ruleListChild.findIndex(its => its.title === key)
      return ind !== -1 ? this.ruleListChild[ind] : ''
    },
    // 切换画布
    changCanvas(index){
      this.$set(this.detailConfig, 'activeConfig', index)
    },
    sliceEncrypt(str, encrypt) {
      return sliceEncrypt(str, encrypt);
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.button-reveal .btn-one), :deep(.button-reveal .btn-three) {
  width: 100% !important;
}
:deep(.button-reveal .icon-img) {
  width: 100% !important;
  height: 100% !important;
}
.custom-box {
  position: relative;
  margin: 0 auto;
}

.el-empty{
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    text-align: center;
  } 
  .vdr{
    border: none !important;
  }
  .drage-area {
    background: url(https://bigdata.topeti.com/PCRepository/middleground/home/images/bg-grid.png) repeat-y;
    background-size: 250% auto;
    -webkit-transition: min-height .3s;
    transition: min-height .3s;
  }
  .detail-custom{
    position: relative;
    flex: 1;
    width: 100%;
    transform: translateX(-50%);
    left: 50%;
    .detail-canvas-top{
      width: 100%;
      flex: 1;
      margin-bottom: 5px;
      border-bottom:1px solid #F0F0F0;
      background-color: #fff;
      display: flex;
      justify-content: start;
      overflow: hidden;
      overflow-x: auto;
      .canvas-item{
        padding: 5px 15px;
        cursor: pointer;
        box-sizing: border-box;
        border-right:1px solid #F0F0F0;
        white-space: nowrap;
        position: relative;
        &:hover .del {
            display: inline-block !important;
          }
        .del{
          position: absolute;
          top: -2px;
          right: -3px;
          display: none;
          background-color: #fff;
          border-radius: 50%;
        }
        i{
          color: #38A2FB;
        }
      }
      .active {
        background-color: #38A2FB;
        border: none;
        color: #fff;
      }
    }
    .detail-canvas-main{
      position: absolute;
      transform: translateX(-50%);
      left: 50%;
    }
  }
  // 拖拉元素
  .vue-grid-item{
    background-color: #fff;
    box-sizing: border-box;
    border: 1px dashed #38A2FB;
  }

  .time-week {
    display: inline-block;
    width: 64px;
    text-align: center;
    height: 38px;
    background: #F2F2F2;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: #D8D8D8;
    margin-left: 4px;
    font-size: 14px;
    color: #999999;
  }
  
  :deep(.expand-btn) {
    position: absolute;
    right: 0;
    bottom: 0;
    cursor: pointer;
    color: #4e86ff;
  }
</style>
